/**
 * FontSize Extension for TipTap
 * 
 * This extension adds font size support to the editor.
 */

import { Extension } from '@tiptap/core';

/**
 * FontSize extension that adds font size attributes to textStyle marks
 * 
 * Usage:
 *   editor.chain().focus().setFontSize('16px').run()
 *   editor.chain().focus().unsetFontSize().run()
 */
const FontSize = Extension.create({
  name: 'fontSize',
  
  addGlobalAttributes() {
    return [
      {
        types: ['textStyle'],
        attributes: {
          fontSize: {
            default: null,
            parseHTML: element => element.style.fontSize || null,
            renderHTML: attributes => {
              if (!attributes.fontSize) {
                return {};
              }

              return {
                style: `font-size: ${attributes.fontSize}`
              };
            }
          }
        }
      }
    ];
  },
  
  addCommands() {
    return {
      setFontSize:
        size =>
        ({ chain }) =>
          chain().setMark('textStyle', { fontSize: size }).run(),
      unsetFontSize:
        () =>
        ({ chain }) =>
          chain().setMark('textStyle', { fontSize: null }).removeEmptyTextStyle().run()
    };
  }
});

export default FontSize;

